// Vite injects the configured base path (e.g. '/' or './').
const BASE_URL = import.meta.env.BASE_URL;

const fullUrl = (relative) => {
  const { origin } = document.location;

  // Absolute base (e.g. base '/'): resolve against the origin + base so deep
  // virtual routes like /idcachup/<StudyInstanceUID> don't corrupt the path.
  if (BASE_URL && BASE_URL.startsWith('/')) {
    const base = BASE_URL.replace(/\/$/, ''); // ex: '' for '/', '/app' for '/app/'
    return origin + base + relative; // ex: http://host/itk/image-io
  }

  // Relative base (subdirectory deployment): derive from the current dir.
  const u = new URL(document.location); // ex: http://host/orthanc/volview/index.html
  const pathParts = u.pathname.split('/'); // ex: ['', 'orthanc', 'volview', 'index.html']
  pathParts.pop(); // ex: ['', 'orthanc', 'volview']

  return origin + pathParts.join('/') + relative; // ex http://host/orthanc/volview/itk/image-io
};

const itkConfig = {
  pipelineWorkerUrl: fullUrl('/itk/itk-wasm-pipeline.min.worker.js'),
  imageIOUrl: fullUrl('/itk/image-io'),
  meshIOUrl: fullUrl('/itk/mesh-io'),
  pipelinesUrl: fullUrl('/itk/pipelines'),
};

export default itkConfig;
